// import {
//   BarcodeScanner,
//   SupportedFormat,
// } from '@capacitor-community/barcode-scanner';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { CapacitorBarcodeScanner } from '@capacitor/barcode-scanner';
import { TranslateService } from '@ngx-translate/core';
@Injectable({
  providedIn: 'root',
})
export class BarcodeScannerService {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    private translate: TranslateService
  ) {}

  async openBarcodeScanner() {
    console.log('barcode')

    try {
      const result = await CapacitorBarcodeScanner.scanBarcode({
        hint: 17,
        cameraDirection: 1,
      });
      console.log(result);
      return result.ScanResult;
    } catch (e) {
      throw e;
    }
    
    // this.document.body.classList.add('scanner-active');
    // BarcodeScanner.prepare();
    // // this.document.querySelector('#barcode-container').classList.add('scanner-active');
    // BarcodeScanner.hideBackground();
    // return BarcodeScanner.checkPermission({ force: true }).then(
    //   (checkPermissionResult) => {
    //     if (checkPermissionResult.granted) {
    //       // user granted permission
    //       return BarcodeScanner.startScan({
    //         targetedFormats: [SupportedFormat.PDF_417],
    //       });
    //     }

    //     if (checkPermissionResult.denied) {
    //       // user denied permission
    //       return Promise.reject({
    //         status: 103,
    //         errorMessage: this.translate.instant('error.permission_denied'),
    //       });
    //     }

    //     if (checkPermissionResult.asked) {
    //       // system requested the user for permission during this call
    //       // only possible when force set to true
    //       return Promise.reject({
    //         status: 102,
    //         errorMessage: this.translate.instant('error.permission_requested'),
    //       });
    //     }

    //     if (checkPermissionResult.neverAsked) {
    //       // user has not been requested this permission before
    //       // it is advised to show the user some sort of prompt
    //       // this way you will not waste your only chance to ask for the permission
    //       return Promise.reject({
    //         status: 101,
    //         errorMessage: this.translate.instant(
    //           'error.permission_requesting_first_time'
    //         ),
    //       });
    //       // const c = confirm('We need your permission to use your camera to be able to scan barcodes');
    //       // if (!c) {
    //       //   return false;
    //       // }
    //     }

    //     if (checkPermissionResult.restricted || checkPermissionResult.unknown) {
    //       // ios only
    //       return Promise.reject({
    //         status: 103,
    //         errorMessage: this.translate.instant('error.permission_denied'),
    //       });
    //       // probably means the permission has been denied
    //     }
    //     return Promise.reject({
    //       status: 103,
    //       errorMessage: this.translate.instant('error.permission_denied'),
    //     });
    //   }
    // );
  }

  stopBarcodeScan() {
    // this.document.body.classList.remove('scanner-active');
    // // this.document.querySelector('#barcode-container').classList.remove('scanner-active');
    // BarcodeScanner.showBackground();
    // BarcodeScanner.stopScan();
  }
}
